import { CloudUpload } from "@mui/icons-material";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, styled, Typography } from "@mui/material";
import { useState } from "react";

const UploadNewPerfmonFileForm: React.FC<IUploadNewPerfmonFileFormProps> = ({ open, submitFile, onClose }) => {
    const [selectedFile, setSelectedFile] = useState<File | null>(null)

    const onSubmit = () => {
        if (selectedFile) {
            submitFile(selectedFile)
            setTimeout(resetForm, 500)
        }
    }

    const resetForm = () => {
        setSelectedFile(null)
    }

    const closeForm = () => {
        onClose()
        setTimeout(resetForm, 500)
    }

    const onFileChange = (event: any) => {
        setSelectedFile(event.target.files[0]);
    };

    const VisuallyHiddenInput = styled('input')({
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(50%)',
        height: 1,
        overflow: 'hidden',
        position: 'absolute',
        bottom: 0,
        left: 0,
        whiteSpace: 'nowrap',
        width: 1,
    });

    return (
        <Dialog open={open} fullWidth>
            <DialogTitle>Upload Perfmon File</DialogTitle>
            <DialogContent>
                <Stack direction="row" pt={2} spacing={2} justifyContent="space-between" useFlexGap flexWrap="wrap">
                    <Box display="flex" flexDirection="column" justifyContent="center" minHeight="55px">
                        <Typography> {selectedFile ? selectedFile.name : "No File Selected"}</Typography>
                    </Box>
                    <Button
                        component="label"
                        role={undefined}
                        color="conradEnergyFreshGreen"
                        variant="contained"
                        tabIndex={-1}
                        startIcon={<CloudUpload />}
                        sx={{ height: "55px", minWidth: "144px" }}
                    >
                        Choose File
                        <VisuallyHiddenInput
                            type="file"
                            accept=".csv"
                            onChange={onFileChange}
                            multiple
                        />
                    </Button>
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={onSubmit}>Submit</Button>
                <Button onClick={closeForm}>Cancel</Button>
            </DialogActions>
        </Dialog>
    );
}

export interface IUploadNewPerfmonFileFormProps {
    open: boolean;
    submitFile: (file: File) => void;
    onClose: () => void;
}

export default UploadNewPerfmonFileForm;